import { HttpClient, HttpResponse } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {Attendee} from '../shared/Attendee';
import {TimetableEntry} from '../shared/TimetableEntry';
import {MiniBookAdminService} from './mini-book-admin.service';

export class AttendeesService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getAllAttendees(): Observable<Attendee[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/attendees`).pipe(
      map<any[], Attendee[]>(data => data.map(value => Attendee.createFromJson(value)))
    );
  }

  get(id: number): Observable<Attendee> {
    return this.http.get<any>(`${this.adminService.tenant}/attendees/${id}`).pipe(
      map<any, Attendee>(data => Attendee.createFromJson(data))
    );
  }

  getTimetable(id: number): Observable<TimetableEntry[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/attendees/${id}/timetable`).pipe(
      map<any[], TimetableEntry[]>(data => data.map(value => TimetableEntry.createFromJson(value)))
    );
  }

  getTimetablePdfUrl(id: number): Observable<Blob> {
    return this.http.get(`${this.adminService.tenant}/attendees/${id}/timetable/pdf`, {responseType: 'blob'});
  }

  timetablePdfUrlWithToken(id: number, filename: string): string {
    let baseUrl = `${this.adminService.baseUrl}${this.adminService.tenant}/attendees/${id}/timetable/pdf/request/${filename}`;
    if (this.adminService.token) {
      return baseUrl + '?access_token=' + this.adminService.token;
    } else {
      return baseUrl;
    }
  }

  update(attendee: Attendee): Observable<Attendee> {
    return this.http.put<any>(`${this.adminService.tenant}/attendees/${attendee.id}`, attendee.toJson()).pipe(
      map<any, Attendee>(data => Attendee.createFromJson(data))
    );
  }

  delete(attendee: Attendee): Observable<void> {
    return this.http.delete<void>(`${this.adminService.tenant}/attendees/${attendee.id}`);
  }

  deleteAllUsers() {
    return this.http.delete<void>(`${this.adminService.tenant}/attendees`);
  }

  downloadAttendeeList(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.adminService.tenant}/attendees/export/csv`, {observe: 'response', responseType: 'blob'});
  }
}
